module.exports = __webpack_public_path__ + "img/制御工学6_6_1.8055284b.png";